import { createRoot } from "react-dom/client";

import App from "./app";
import * as serviceWorker from "./serviceWorker";
import "assets/scss/index.scss";
import "assets/scss/variables.scss";
import { APP_TITLE, REWARDFUL_KEY } from "config_environment";

document.title = APP_TITLE;

// Load Rewardful script only for configured hostnames (e.g. TGP)
if (REWARDFUL_KEY) {
	const rw = document.createElement("script");
	rw.textContent = `(function(w,r){w._rwq=r;w[r]=w[r]||function(){(w[r].q=w[r].q||[]).push(arguments)}})(window,'rewardful');`;
	document.head.appendChild(rw);

	const rwAsync = document.createElement("script");
	rwAsync.async = true;
	rwAsync.src = "https://r.wdfl.co/rw.js";
	rwAsync.setAttribute("data-rewardful", REWARDFUL_KEY);
	document.head.appendChild(rwAsync);
}

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
